<template>
  <div class="mb-3">
    <template v-if="loadComponent">
      <template v-if="hasSlot('title')">
        <v-row>
          <v-col class="pl-1">
            <div>
              <slot name="title" />
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-if="showForm">
        <component
          :is="form"
          from-form-layout
          :initialData.sync="allInitialData"
          :showData="showDataLocal"
          :action="action"
          :step="step"
          :customResource="customResource"
          :validateServiceAction="validateServiceAction"
          v-bind="formProps"
          @validate="handleValidateEvent"
          @submit="submit"
          @reset:step="$emit('update:step', undefined)"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { findLast, camelCase } from 'lodash';
import hasSlot from '@/mixins/hasSlot';
import form from '@/mixins/form';

export default {
  mixins: [form, hasSlot],
  props: {
    //conditionally rending of form component
    showForm: {
      type: Boolean,
      default: true,
    },
    //we can control the step of the form with this prop. it can be updated both ways. from Input file to Form, and from Form to Input file
    step: {
      type: Number,
      default: undefined,
    },
    // custom show route for where we want to return after posting/patching a form successfully.
    // by default the routing is automatic, only when a value is provided does the custom routing is enabled
    // DEV NOTE: Unify with redirectRouteObject
    showRoute: {
      type: String,
      default: undefined,
    },
    /* DEV NOTE: Further work to be done here while we migrate all the app modules
    //custom new route, disables automatic routing after posting a form succesfully, and instead emits an event listener
    //from where we can do our own routing logic 
    /*enableAutomaticRoutingNew: {
      type: Boolean,
      default: false,
    },*/
    routeParamId: {
      type: String,
      default: undefined,
    },
    // Custom route object for return after patch / post
    redirectRouteObject: {
      type: Object,
      required: false,
    },
    disableRedirect: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getRouteParamId();
  },
  data() {
    return {
      submitted: false,
    };
  },
  watch: {
    activeUploads: {
      handler(val) {
        if (val.length < 1 && this.submitted) {
          this.handleRedirect();
        }
      },
    },
    submitted: {
      handler(val) {
        if (this.activeUploads.length < 1 && val) {
          this.handleRedirect();
        }
      },
    },
  },
  methods: {
    findLast,
    async handleValidateEvent(formData, callback) {
      try {
        const data = await this.handleValidate(formData);
        if (callback && typeof callback === 'function') {
          callback(data);
        }
        return data;
      } catch (e) {
        console.log(e);
        if (callback && typeof callback === 'function') {
          callback({ errors: [] });
        }
        throw e;
      }
    },
    async submit(payload) {
      this.submitted = false;
      try {
        await this.executeServiceAction(payload);
        if (this.object) this.submitted = true;
      } catch (e) {
        console.log(e);
      }
    },
    handleRedirect() {
      if (!this.object) return;
      if (this.disableRedirect) this.$emit('new:route', this.object);
      else this.redirect();
    },
    redirect() {
      if (this.disableRedirect) return;
      var showRouteName;
      if (this.showRoute) {
        showRouteName = {
          name: this.showRoute,
          params: {
            id: this.object?.id,
          },
        };
      } else {
        /*
          REFACTOR: To use standard router way of routing
          use e.g. showRouteName = { name: 'Address', params: { id: 4 }
          instead of directly using the path as a string e.g. 'addresses/4'
        */
        var path = this.$route.fullPath;
        var indexForRemovingAction = path.lastIndexOf('/') + 1;
        showRouteName = path.substring(0, indexForRemovingAction);

        if (this.action == 'new') {
          //conatenate id of new record to the path (e.g. admin/accounts/ -> admin/accounts/7)
          showRouteName = showRouteName + this.object?.id;
        }
      }
      this.$router.push(this.redirectRouteObject || showRouteName);
    },
    getRouteParamId() {
      if (this.routeParamId) {
        this.routeParamIdLocal = this.routeParamId;
      } else {
        //automatic routeParamId by concatenating route resource with 'Id'
        var resourceRoute = this.findLast(this.$route.matched, function(route) {
          return route.meta.resource;
        });
        var resource = camelCase(resourceRoute.meta?.resource);

        if (
          resource &&
          Object.prototype.hasOwnProperty.call(
            this.$route.params,
            resource + 'Id'
          )
        ) {
          this.routeParamIdLocal = resource + 'Id';
        }
      }
    },
  },
};
</script>
